import PropTypes from 'prop-types';

const graphic = PropTypes.shape({
  src: PropTypes.string,
  type: PropTypes.string,
  graphictype: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  credit: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
});

export default {
  graphic,
  graphics: PropTypes.arrayOf(graphic),
};
